var map = {
	"./DistrictMunicipalities_2018.geo": [
		55205,
		205
	],
	"./DistrictMunicipalities_2018.geo.json": [
		55205,
		205
	],
	"./Filters": [
		53145,
		145
	],
	"./Filters.json": [
		53145,
		145
	],
	"./LocalMunicipalities_2016.geo": [
		2544,
		544
	],
	"./LocalMunicipalities_2016.geo.json": [
		2544,
		544
	],
	"./Metros_hex.geo": [
		55617,
		617
	],
	"./Metros_hex.geo.json": [
		55617,
		617
	],
	"./Province_2018.geo": [
		68147,
		147
	],
	"./Province_2018.geo.json": [
		68147,
		147
	],
	"./SA_Metros.geo": [
		89106,
		106
	],
	"./SA_Metros.geo.json": [
		89106,
		106
	],
	"./sic_codes": [
		94654,
		654
	],
	"./sic_codes.json": [
		94654,
		654
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 90487;
module.exports = webpackAsyncContext;